import { createContext, useContext, useState } from "react";

export const OrderContext = createContext();

export const OrderProvider = ({ children }) => {
  const [orderInfo, setOrderInfo] = useState();
  const [selectReturnItem, setSelectReturnItem] = useState("");
  const [isSelected, setIsSelected] = useState();
  const [recentOrderID, setRecentOrderID] = useState();
  const [variantID, setVariantID] = useState();
  const [productID, setProductID] = useState();
  const [incentive, setIncentive] = useState();
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);

  return (
    <OrderContext.Provider
      value={{
        orderInfo,
        setOrderInfo,
        selectReturnItem,
        setSelectReturnItem,
        isSelected,
        setIsSelected,
        recentOrderID,
        setRecentOrderID,
        variantID,
        setVariantID,
        productID,
        setProductID,
        incentive,
        setIncentive,
        isBtnDisabled,
        setIsBtnDisabled,
      }}
    >
      {children}
    </OrderContext.Provider>
  );
};
export const useOrderContext = () => {
  return useContext(OrderContext);
};
